<template>
  <Report
    :report-id="reportId"
    title="Billable Conversations"
    tooltip-text="A billable conversation is classified as a contact who has sent at least one message in the month. If the contact has sent/received more than 20 messages in a month, each additional set of up to 20 messages is counted as another billable conversation."
    class="chart-container"
    :data-empty="isDataEmpty"
    :loaded-data="isDataLoaded"
    :loading-error="loadingError"
  >
    <template #chart>
      <BarChart :reportId="reportId" class="chart" :data="reportData" :seriesOrder="seriesOrder" />
    </template>
  </Report>
</template>

<script lang="ts" setup>
import BarChart from '../chartjs/BarChart.vue';
import { Data, SeriesConfig } from '../../models';
import { computed, PropType } from 'vue';
import { useReportData } from '@/features/reports/util/useReportData';
import Report from '@/features/reports/components/Report.vue';

const props = defineProps({
  data: {
    type: Object as PropType<Data>,
    required: true,
  },
  loadedData: {
    type: Boolean,
    default: false,
  },
  loadingError: {
    type: Boolean,
    default: false,
  },
});

const { reportId, isDataEmpty, isDataLoaded, createBlankSeries } = useReportData(props);

const seriesOrder: SeriesConfig[] = [{ name: 'Conversations', displayName: 'Billable Conversations' }];

const reportData = computed<Data>(() => ({
  scale: props.data.scale,
  series: seriesOrder.map((seriesConfig) => {
    return (
      props.data.series.find((s) => s.name === seriesConfig.name) ||
      createBlankSeries(seriesConfig.name, seriesConfig.displayName)
    );
  }),
}));
</script>

<style scoped lang="scss">
@use '@/features/reports/components/reports.scss' as *;
</style>
